import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { GlobalComponent } from '../global';
import { CheckoutService } from '../../services/checkout';
import { StorageKeysEnum } from '../constants';

@Injectable()
export class CanActivateCheckoutGuard  {

	constructor(private _router: Router, private _checkoutService: CheckoutService) {
	}

	canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (state.url.includes('/pago/procesando')) return true;

		if (!this._checkoutService.getIsFromOffers() && (!GlobalComponent.appGroupSeleted || this._checkoutService.isFinishPayment)) {
			const searchParams = localStorage.getItem(StorageKeysEnum.SEARCH_PARAMS);
			this._router.navigateByUrl(searchParams ? `/resultados?${searchParams}` : '/').then(() => null);
			return false;
		}

		return true;
	}
}